module.exports = __webpack_public_path__ + "static/media/correct.4b708693.mp3";